export const UNAUTH_USER = 'unauth_user';

export function unauthUser() {
	return {
		type: UNAUTH_USER,
		payload: null
	
  };

}


// WEBPACK FOOTER //
// ./src/redux/actions/errorsActions.js